import { inputsV2 } from '@ecosystem/newron-design-system';

export const WithSelect = ({ options, value, onChange, ...otherProps }) => {
  const { Select } = inputsV2;

  return (
    <div className="retail-insights-select-menu">
      <Select options={options} value={value} onChange={onChange} combobox {...otherProps} />
    </div>
  );
};
